import { useEffect, useState } from 'react';
import ScrollToTop from '../../../../components/scrollToTop/scrollToTop';
import './passwordExp.css';
import { GrAdd } from "react-icons/gr";
import { useForm } from 'react-hook-form';
import axios from 'axios';
import Swal from 'sweetalert2';

function PasswordExp() {
  const user = JSON.parse(localStorage.getItem("user")); // Convertir a objeto
  const [statusModal, setStatusModal]=useState(false);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({mode: 'onChange'});
  const [lastUpdateInfo, setLastUpdateInfo]=useState("")
  const [historyPass, setHistoryPass]=useState([]);
  const [currentUser, setCurrentUser]=useState({});
  const [isUpdating, setIsUpdating] = useState(false);


  useEffect(() => {
    getOnePass();
  }, []);

  const updateTimePassed = (lastDate) => {
    const lastUpdateDate = new Date(lastDate);
    const now = new Date();
    const difference = now - lastUpdateDate;

    const seconds = Math.floor(difference / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30);
    const years = Math.floor(months / 12);

    let formattedTime;

    if (years > 0) {
      formattedTime = `${years} año${years > 1 ? 's' : ''}`;
    } else if (months > 0) {
      formattedTime = `${months} mes${months > 1 ? 'es' : ''}`;
    } else if (days > 0) {
      formattedTime = `${days} día${days > 1 ? 's' : ''}`;
    } else if (hours > 0) {
      formattedTime = `${hours} hora${hours > 1 ? 's' : ''}`;
    } else if (minutes > 0) {
      formattedTime = `${minutes} minuto${minutes > 1 ? 's' : ''}`;
    } else {
      formattedTime = `${seconds} segundo${seconds > 1 ? 's' : ''}`;
    }

    return formattedTime;
  }

  const openModal = async () => {
    setStatusModal(true)
    try {
      const url = `${process.env.REACT_APP_URL_BACKEND}/api/v1/password_expirations/getAllDeleted`;
      const token = `Bearer ${sessionStorage.getItem("token")}`;
      const response = await axios.get(url, {headers: {Authorization: token}});

      setHistoryPass(response.data.data);

    } catch (error) {
      
    }
  }

  const closeModal = () => {
    setStatusModal(false)
  }

  const handlePasswordSubmit = async (passData) => {
    setIsUpdating(true); 
    try {
      const body = {
        "time": passData.Periodicidad,
        "type": parseInt(passData.typePass),
        "user_id": 1
      }
      const url = `${process.env.REACT_APP_URL_BACKEND}/api/v1/password_expirations/store`;
      const token = `Bearer ${sessionStorage.getItem("token")}`;
      const response = await axios.post(url, body, {headers: {Authorization: token}});

      console.log(response);
      Swal.fire("Actualizado!", "El elemento ha sido Actualizado.", "success");
      setIsUpdating(false);
    } catch (error) {
      console.log(error);
      setIsUpdating(false);
      Swal.fire("Error", "Hubo un error", "error");
    }


  }

  const getOnePass = async() => {
    try {
      const url = `${process.env.REACT_APP_URL_BACKEND}/api/v1/password_expirations`;
      const token = `Bearer ${sessionStorage.getItem("token")}`;
      const response = await axios.get(url, {headers: {Authorization: token}});
      const currentInfo = response.data.data;

      setCurrentUser(currentInfo[0])
      setValue("Periodicidad", currentInfo[0].time);
      setLastUpdateInfo(updateTimePassed(currentInfo[0].updated_at));
      switch (currentInfo[0].type) {
        case "dias":
          setValue("typePass", "1");
          break;
        case "semanas":
          setValue("typePass", "2");
          break;
        case "meses":
          setValue("typePass", "3");
          break;
        case "años":
          setValue("typePass", "4");
          break;
        default:
          setValue("typePass", "1");
          break;
      }

    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  }
  
  return(
    <>
      <ScrollToTop />
      {statusModal && (
        <div className="backgroundmodalPass" onClick={closeModal}>
          <div className="modalWindowPass" onClick={(e) => e.stopPropagation()}>
            <div className="headerModal">
              <p>Histórico</p>
              <GrAdd className='iconClose' onClick={closeModal} />
            </div>

            <div className="bodyModal">
              <table className='table table-responsive'>
                <thead>
                  <tr>
                    <th scope='col'>Periodicidad</th>
                    <th scope='col'>Tipo</th>
                    <th scope='col'>Usuario</th>
                    <th scope='col'>Fecha</th>
                  </tr>
                </thead>
                <tbody>
                  {historyPass.slice().reverse().map((password) => (
                    <tr key={password.id}>
                      <td>{password.time}</td>
                      <td>{password.type}</td>
                      <td>{password.user_id}</td>
                      <td>{new Date(password.updated_at).toLocaleString()}</td>
                      {/* <td>{new Date(password.updated_at).toLocaleDateString()}</td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            
          </div>
        </div>
      )}

      <div className='passwordExpCotainer'>
        <form
          onSubmit={handleSubmit(handlePasswordSubmit)}
          className='passwordExpForm'
        >

          <div className='inputsContainer'>

            <div className='form-group'>
              <label htmlFor="street" className="col-sm-12 text-start">
                Periodicidad
              </label>
              <input 
                id='Periodicidad'
                className={`form-control`}
                name='Periodicidad'
                type='number'
                {...register("Periodicidad", {
                  required: true
                })}
              />
              {errors.name?.type === "required" && (
                <p className='errorText'>Campo requerido</p>
              )}
            </div>
            <div className='form-group'>
              <label>Type</label>
              <select
                id='typePass'
                className={`form-control`}
                name='typePass'
                {...register("typePass")}
              >
                <option value="1">Dias</option>
                <option value="2">Semanas</option>
                <option value="3">Meses</option>
                <option value="4">Años</option>
              </select>
            </div>

          </div>

          {!isNaN(lastUpdateInfo) && (
            <p className='lastUpdateText'>
              Última actualización: hace {lastUpdateInfo}
            </p>
          )}

          <div className='buttonsContainer'>
            <button className="btnn" type='button' onClick={openModal}>Historial</button>
            <button className="btnn" type='submit' disabled={isUpdating}>Actualizar</button>
          </div>

        </form>
      </div>
    </>
  )
}

export default PasswordExp;